// extracted by mini-css-extract-plugin
export default {"wrapper":"FlatsTable_wrapper__zpPee"};